/* This file is generated by a script. Do not modify. */

export const supportedComponents = [
  'Button',
  'Box',
  'ComparisonTable',
  'FAQ',
  'Heading',
  'Image',
  'Label',
  'SectionIntro',
  'Stack',
  'Testimonial',
  'Text',
  'Timeline',
  'Animate',
  'River',
  'RiverBreakout',
]
